import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAxios from 'utils/useAxios';
import Cookies from 'js-cookie';
import { isRefreshTokenExpired } from 'utils/auth';

const HistoricalEventsContext = createContext();

export function HistoricalEventsProvider({ children }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const api = useAxios();
    const { isLoggedIn } = useSelector((state) => state.account);
    const refresh_token = Cookies.get('refresh_token');
    const loggedIn = isLoggedIn && !isRefreshTokenExpired(refresh_token);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await api.get('/history-storms/');
                setData(response.data);
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };

        if (loggedIn) {
            fetchData();
        }
    }, [loggedIn]);

    return <HistoricalEventsContext.Provider value={{ data, loading }}>{children}</HistoricalEventsContext.Provider>;
}

export function useHistoricalEventsData() {
    return useContext(HistoricalEventsContext);
}
